import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

import * as Sentry from '@sentry/vue'

import PrimeVue from 'primevue/config'

import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import ToastService from 'primevue/toastservice'

import Tooltip from 'primevue/tooltip'

import { permissionDirective } from '@/modules/permission/directive/permission.ts'

import 'primevue/resources/themes/aura-light-blue/theme.css'

import '@/assets/styles.scss'

const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 0.5, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.5, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)

app.use(PrimeVue, { ripple: true })

app.use(ToastService)
app.use(DialogService)
app.use(ConfirmationService)
app.directive('tooltip', Tooltip)

app.directive('permission', permissionDirective)

// Initialize API with CSRF token
// await initializeAPI()

// Configure reCAPTCHA v3
app.use(VueReCaptcha, {
  siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY, // Store in .env file
  loaderOptions: {
    autoHideBadge: false, // Set to true if you want to hide the badge
    explicitRenderParameters: {
      badge: 'bottomright', // 'bottomright', 'bottomleft', or 'inline'
    },
  },
})


app.mount('#app')
